import * as React from "react";
import { forwardRef } from "react";
const SvgColon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 5, height: 14, viewBox: "0 0 5 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 2.5, cy: 2, r: 2, fill: "#D9D9D9" }), /* @__PURE__ */ React.createElement("circle", { cx: 2.5, cy: 12, r: 2, fill: "#D9D9D9" }));
const ForwardRef = forwardRef(SvgColon);
export { ForwardRef as ReactComponent };
